import React, { Component, PropTypes } from 'react';
import styles from './Circle.scss';



class Circle extends Component {
  constructor(props) {
    super(props);
    this.setInfo = props.showInfoHandler;

    this.showInfo = this.showInfo.bind(this);
  }

  showInfo() {
    this.setInfo();
  }

  render() {
  	let curRadius = this.props.cur !== null ? this.props.cur / this.props.max * this.props.radius : this.props.radius;
  	let maxRadius = this.props.cur !== null ? this.props.radius : null;
    let headlinePos = this.props.headlinePos ==  'top' ? (this.props.radius + 20) * -1 : (this.props.radius + 40)
    let maxCount = Math.floor(curRadius / 50) + 1;
    let primaryColor = this.props.colors.primary;
    let secondaryColor = this.props.colors.secondary;

    if (! curRadius) {
      curRadius = 13;
      maxRadius = null;
      primaryColor = this.props.colors.hidden;
      headlinePos = this.props.headlinePos ==  'top' ? (curRadius + 20) * -1 : (curRadius + 40)
    }

    let pulses = [];    

    if (this.props.pulse) {
    let start = this.props.pulse === 'grow' ? 0 : curRadius;
    let end = start === 0 ? curRadius : 0 ;

    for (var i = 0; i < maxCount; i++) {
        pulses.push(
          <circle 
            key={'circle'+i}
            r={1}
            fill="transparent"
            stroke="rgba(255,255,255,1)" 
            cx={this.props.locX}
            cy={this.props.locY}
            onClick={this.props.onClick}
            >
            <animate attributeName="r"
              from={start} 
              to={end}
              dur={curRadius / 20}
              begin={i*2}
              repeatCount="indefinite"
            />
            <animate attributeName="stroke-width"
              from={0} 
              to={8}
              dur={curRadius / 20}
              begin={i*2}
              repeatCount="indefinite"
            />
            <animate attributeName="stroke"
              from="rgba(255,255,255,1)"
              to="rgba(255,255,255,0)"
              dur={curRadius / 20}
              begin={i*2}
              repeatCount="indefinite"
            />
          </circle>
        );
    }
  }

	return (
		<g>
			{maxRadius && 
				<circle className="max"
					cx={this.props.locX}
					cy={this.props.locY}
					r={maxRadius} 
					fill={secondaryColor}
				/>
			}

			<circle className={"cur" + (this.props.cur ? ' pulsing down' : '')}
				cx={this.props.locX}
				cy={this.props.locY}
				r={curRadius} 
				fill={primaryColor}
        onClick={this.props.onClick}
        style={{}}
			/>
      <g>
        {pulses}
      </g>
      {this.props.showLegend && 
      <text
        x={this.props.locX}
        y={this.props.locY + headlinePos}
        textAnchor='middle'
        style={TitleStyle}
        >
        {this.props.title}
      </text>
      }
		</g>
		);
	}
}

const TitleStyle = {
  font: 'normal normal normal 30px Arial, Helvetica, sans-serif',
  backgroundColor: 'rgb(236,246,255)',
  padding: '10px'
}


Circle.propTypes = {
  title: PropTypes.string.isRequired,
  locX: PropTypes.number.isRequired,
  locY: PropTypes.number.isRequired,
  radius: PropTypes.number.isRequired,
  max: PropTypes.number,
  min: PropTypes.number,
  cur: PropTypes.number,
  colors: PropTypes.object
};

Circle.defaultProps = {
  title: 'Title',
  locX: 0,
  locY: 0,
  radius: 100,
  max: null,
  min: null,
  cur: null,
  colors: {
  	primary: 'green',
  	secondary: 'red'
  },
  pulse: null
};

export default Circle;


// WEBPACK FOOTER //
// ./src/views/Bubbles/Circle.jsx